import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';

import { useAppMetamask } from 'features/wallets/context/app-metamask-context';
import { Button } from 'ui';

import { WalletAddress } from '../../wallets-types';

export interface WalletsListProps {
  walletEnabled: boolean;
  account: string;
  wallets: WalletAddress[];
  limits: Record<string, number>;
  processing: boolean;
  onRemove: (id: string) => void;
  onApprove: () => void;
  onRevoke: () => void;
}

const WalletsList: React.FC<WalletsListProps> = ({
  account,
  processing,
  wallets,
  limits,
  walletEnabled,
  onRemove,
  onApprove,
  onRevoke,
}) => {
  const { getBalance, getAllowance } = useAppMetamask();
  const [balance, setBalance] = useState<number>();
  const [allowance, setAllowance] = useState<number>();
  const { t } = useTranslation(['wallets']);

  useEffect(() => {
    const asynbcFunc = async () => {
      if (wallets.length > 0) {
        setBalance(await getBalance(wallets[0].address));
        setAllowance(await getAllowance(wallets[0].address));
      }
    };

    asynbcFunc();
  }, [wallets]);

  if (wallets.length === 0) {
    return null;
  }

  return (
    <>
      {wallets.map((wallet) => (
        <div key={wallet.address}>
          <b style={{ overflowWrap: 'anywhere' }}>{wallet.address}</b>
          <br />
          Баланс: {balance ?? ''} vts
          <br />
          Разрешенный лимит: {allowance ?? ''} vts
          <br />
          <br />
          <Button
            onClick={() => onRemove(wallet.id)}
            size="small"
            disabled={processing}
            outline
          >
            Удалить адрес
          </Button>
        </div>
      ))}
    </>
  );
};

export default WalletsList;
